module.exports = new __parcel__URL__("dynamoDB.146d7e99.svg").toString();